/**
 * Iteration 1's ruleset, wrapped behind the `Ruleset` seam. No kong, no
 * scoring — the six shipped lessons and every pre-existing test implicitly
 * use this ruleset, so its behavior must stay exactly what iteration 1
 * shipped: `scoreHand` never returns a score.
 */

import type { HandScore, Ruleset, ScoringContext } from './types.js';

export const SimplifiedRuleset: Ruleset = {
  id: 'simplified',
  kongEnabled: false,
  alternateWinShapes: false,
  scoreHand(_context: ScoringContext): HandScore | null {
    return null;
  },
};
